import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';
import { newProductsBoardWithDefaultFields } from '../features/end_user_shopping/services/shopping_lists';

const client = generateClient();

export const ensureDefaultProductsBoardExists = async (
  currentSpaceMembershipID,
  lazyListProductsBoard,
  createProductsBoard,
) => {
  const { data: productsBoard } = await lazyListProductsBoard(undefined, true);
  if (productsBoard) {
    return productsBoard;
  }
  const { data: newProductsBoard } = await createProductsBoard(
    newProductsBoardWithDefaultFields(currentSpaceMembershipID),
  );
  return newProductsBoard;
};

export const shareShoppingListViaEmailOperation = async (
  shoppingList,
  recipient,
  senderName,
) => {
  const response = await client.graphql({
    query: mutations.emailShoppingList,
    variables: {
      shoppingList,
      recipient,
      senderName,
    },
  });
  return response.data.emailShoppingList;
};

// const migrateShoppingListCopyOfMeal = async (mealID) => {
//   try {
//     const boardMeal = await getMeal(mealID);
//     return shoppingListMealFromMeal(boardMeal);
//   } catch (e) {
//     console.log(e);
//     return { mealID, recipes: [] };
//   }
// };

// const migrateShoppingListOldVersion = async (shoppingList) => {
//   if (shoppingList.schemaVersion >= CURRENT_SHOPPING_LIST_SCHEMA_VERSION) {
//     return shoppingList;
//   }
//   if (shoppingList.schemaVersion === 1) {
//     const meals = await Promise.all(
//       shoppingList.mealIDs.map(migrateShoppingListCopyOfMeal),
//     );
//     return {
//       ...shoppingList,
//       schemaVersion: CURRENT_SHOPPING_LIST_SCHEMA_VERSION,
//       meals,
//       mealIDs: [],
//       mealImageUrls: [],
//     };
//   }
//   return shoppingList;
// };

// const migrateShoppingListsOldVersion = async (shoppingLists) => {
//   const oldVersionListsToMigrate = Object.values(shoppingLists).some(
//     (list) => list.schemaVersion < CURRENT_SHOPPING_LIST_SCHEMA_VERSION,
//   );
//   if (!oldVersionListsToMigrate) {
//     return shoppingLists;
//   }
//   const migratedShoppingListsList = await Promise.all(
//     Object.values(shoppingLists).map(migrateShoppingListOldVersion),
//   );
//   const migratedShoppingLists = { ...shoppingLists };
//   Object.keys(migratedShoppingLists).forEach((id, index) => {
//     migratedShoppingLists[id] = migratedShoppingListsList[index];
//   });
//   await Promise.all(migratedShoppingListsList.map(updateShoppingListOperation));
//   return migratedShoppingLists;
// };

// const migrateShoppingListsSpaceMembership = async (
//   shoppingLists,
//   currentSpaceMembershipID,
// ) => {
//   const migratedShoppingLists = { ...shoppingLists };
//   // eslint-disable-next-line no-restricted-syntax
//   for (const shoppingList of Object.values(shoppingLists)) {
//     if (currentSpaceMembershipID && !shoppingList.spaceMembershipID) {
//       const migratedShoppingList = {
//         ...shoppingList,
//         spaceMembershipID: currentSpaceMembershipID,
//       };
//       migratedShoppingLists[shoppingList.id] =
//         // eslint-disable-next-line no-await-in-loop
//         await updateShoppingListOperation(migratedShoppingList);
//     }
//   }
//   return migratedShoppingLists;
// };

// export const migrateShoppingLists = async (
//   shoppingLists,
//   currentSpaceMembershipID,
// ) => {
//   let updatedShoppingLists = await migrateShoppingListsOldVersion(
//     shoppingLists,
//   );
//   updatedShoppingLists = await migrateShoppingListsSpaceMembership(
//     shoppingLists,
//     currentSpaceMembershipID,
//   );
//   return updatedShoppingLists;
// };
